<template>
  <!-- .et ex-tool -->
  <div>
    <div class="et">
      <div class="item item-icon" v-if="curIndex == 0" @click="toolHandle('ting')">
        <!-- <img src="@/assets/img/live/tool-icon-ting.png" class="img2 icon"/> -->
        <div class="item-box hall">
          <!-- <img src="@/assets/img/live/icon-ting.png" class="icon2"/> -->
          <i class="icon iconfont icon-zhanting-copy"></i>
          <span>主页</span>
        </div>
      </div>
      <div class="item item-icon" v-if="curIndex == 0" @click="toolHandle('talk')">
        <!-- <img src="@/assets/img/live/tool-icon-talk.png" class="img2 icon" /> -->
        <div class="item-box talk">
          <!-- <img src="@/assets/img/live/icon-talk.png" class="icon2"/> -->
          <i class="icon iconfont icon-zixun"></i>
          <span>咨询</span>
        </div>
      </div>
      <div class="item item-icon" v-if="curIndex == 0 && isReg && !actData.enabledBuyingTicket" @click="toolHandle('join')">
        <!-- <img src="@/assets/img/live/tool-icon-join.png" class="img2 icon" /> -->
        <div class="item-box join">
          <!-- <img src="@/assets/img/live/icon-join.png" class="icon2"/> -->
          <i class="icon iconfont icon-iconfont-baoming-copy"></i>
          <span>报名</span>
        </div>
      </div>
      <div class="item item-icon" v-if="curIndex == 0 && actData.enabledBuyingTicket" @click="toolHandle('order')">
        <!-- <img src="@/assets/img/live/tool-icon-join.png" class="img2 icon" /> -->
        <div class="item-box join">
          <!-- <img src="@/assets/img/live/icon-join.png" class="icon2"/> -->
          <i class="icon iconfont icon-piaoju"></i>
          <span>购票</span>
        </div>
      </div>
      <div class="item item-icon" v-if="false && curIndex == 0 && type == 'live' && actData.enabledGift" @click="toolHandle('gift')">
        <!-- <img src="@/assets/img/live/tool-icon-gift.png" class="img2 icon" /> -->
        <div class="item-box gift">
          <img src="@/assets/img/live/icon-gift.png" class="icon2"/>
          <span>礼物</span>
        </div>
      </div>
      <div class="item item_hot" v-if="curIndex == 2" @click="toolHandle('hot')">
        <img src="@/assets/img/live/tool-icon-hot.png" class="img2 icon3" />
      </div>
      <div class="item item_topic" v-if="curIndex == 6" @click="toolHandle('public')">
        <img src="@/assets/img/new/topic_ic.png" class="img2 icon3" />
      </div>
      <div class="item itme_live" v-if="curIndex == 7 && type == 'live'" @click="toolHandle('live')">
        <img src="@/assets/img/live/tool-icon-live.png" class="img2 icon3" />
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "ex-tool",
  props:['curIndex','type','regMsg','actData'],
  data() {
    return {};
  },
  computed:{
    isReg(){
      console.log(this.regMsg,'regMsg');
      if(!this.regMsg.regStartAt && !this.regMsg.regEndAt){ // 没有报名时间
        return false
      } else{
        let startAt = this.regMsg.regStartAt;
        let endAt = this.regMsg.regEndAt;
        startAt = startAt.replace(/\-/g, "/");
        endAt = endAt.replace(/\-/g, "/");
        let state = this.compareDate(startAt, endAt);
        if(state == 1) {
          return true
        } else {
          return false
        }
      }
    }
  },
  created(){
    console.log(this.isReg,'isReg',this.actData);
  },
  methods: {
    toolHandle(type) {
      this.$emit("toolTouch", type);
    },
    compareDate(statedate, enddate) {
      const stateTime = new Date(statedate).getTime();
      const Time = new Date().getTime();
      const endTime = new Date(enddate).getTime();
      if (stateTime < Time && Time < endTime) {
        return 1; //进行中
      } else if (endTime < Time) {
        return 2; //已结束
      } else {
        return 3; //未开始
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.et {
  position: fixed;
  z-index: 12;
  bottom: 1.18rem;
  right: 0.3rem;
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  width: 0.92rem;
  justify-content: center;
  .item {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    text-align: center;
    line-height: 1rem;
    align-items: center;
    justify-content: center;
    margin-top: 0.15rem;
    position: relative;
    &.item_topic{
       box-shadow: 0 0.05rem 0.1rem 0 
		rgba(1, 44, 126, 0.4);
    }
    &.item_hot{
      box-shadow: 0 0.05rem 0.1rem 0 
		rgba(#970700, 0.4);
    }
    &.itme_live{
      box-shadow: 0 0.05rem 0.1rem 0 
		rgba(#4f2b6d, 0.4);
    }
    .icon3 {
      width: 1rem;
      height: 1rem;
    }
    .iconfont{
      line-height: 1;
      font-size: .32rem;
    }
  }
  .item3 {
    width: 1rem;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .item2 {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
    color: #ff416c;
    padding-top: 0.1rem;
    margin-top: 0.3rem;
    position: relative;

    img {
      display: block;
      width: 1rem;
      height: 1rem;
      border: 0.04rem solid #fff;
      border-radius: 50%;
    }
    &-txt {
      font-size: 0.2rem;
      position: absolute;
      width: 0.92rem;
      height: 0.38rem;
      line-height: 0.38rem;
      background-color: #fff;
      box-shadow: 0px 0.03rem 0.07rem 0px rgba(0, 0, 0, 0.2);
      border-radius: 0.18rem;
      border: solid 0.02rem #ff4b1b;
      bottom: -0.19rem;
    }
    &.s-red {
      background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
        linear-gradient(#fff, #fff);
      color: #fff;
    }
  }
}
.img1 {
  width: 0.35rem;
  height: 0.43rem;
}
.img2 {
  width: 0.4rem;
  height: 0.38rem;
}
.img3 {
  width: 0.37rem;
  height: 0.4rem;
}
.z-side {
  position: relative;
  .list {
    flex: 1;
    width: 3.33rem !important;
    height: 0.92rem;
    position: absolute;
    right: 1.02rem;
    top: 0;
    .list-box {
      width: 100%;
      height: 0.92rem;
      padding-right: 0.16rem;
    }
    .item3 {
      width: 100%;
      height: 0.92rem;
      border: 0.02rem solid #e6b54a;
      border-right-color: transparent;
      background-image: url("../../../assets/img/live/crown.png"),
        linear-gradient(90deg, #4b1248 0%, #9e6a62 49%, #f0c27b 100%),
        linear-gradient(#2b1e08, #2b1e08);
      background-repeat: no-repeat;
      background-position: bottom right, 0% 0%;
      background-size: 0.52rem 0.52rem, auto;
      border-radius: 0.06rem;
      position: relative;
      text-align: left;
      padding: 0.1rem;
      display: flex;
      &::after {
        content: "";
        position: absolute;
        right: -0.18rem;
        top: 50%;
        margin-top: -0.1rem;
        border-width: 0.1rem;
        border-style: solid;
        border-color: transparent;
        border-left-color: #ecbe78;
      }
      .logo {
        width: 0.7rem;
        height: 0.7rem;
        border-radius: 0.02rem;
        border: 0.02rem solid #f0cc3a;
        margin-right: 0.1rem;
      }
      .content {
        width: calc(100% - 0.8rem);
        height: 0.7rem;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        p {
          font-size: 0.2rem;
          color: #fff;
          font-weight: bold;
          margin: 0;
          width: 100%;
          line-height: 1.2;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .txt {
          font-size: 0.16rem;
          color: #fff;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 1.2;
        }
        .tag {
          display: flex;
          .info_img {
            width: 0.46rem;
            height: 0.2rem;
            display: flex;
            img {
              width: 0.2rem;
              height: 0.2rem;
              border-radius: 50%;
              border: 1px solid #fff;
              // object-fit: cover;
              &:nth-child(1) {
                position: relative;
                z-index: 3;
              }
              &:nth-child(2) {
                position: relative;
                z-index: 2;
                margin-left: -0.07rem;
              }
              &:nth-child(3) {
                position: relative;
                z-index: 1;
                margin-left: -0.06rem;
              }
            }
          }
          span {
            font-size: 0.14rem;
            margin-left: 0.1rem;
            line-height: 0.2rem;
          }
        }
      }
    }
  }
}
.item-box{
  width: .92rem;
  height: .92rem;
  background-color: #fff;
	box-shadow: 0px 3px 10px 0px 
		rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .icon2{
    width: .3rem;
    height: .3rem;
    margin-top: .08rem;
  }
  span{
    font-size: .2rem;
    line-height: 1.2;
    margin-top: .06rem;
    color: #666;
  }
}
.hall{
  .iconfont,span{
    color: #e53935;
  }
}
.talk{
  .iconfont,span{
    color:#ffbe93;
  }
}
.join{
  .iconfont,span{
    color:#999;
  }
}
</style>